import React from 'react'

const aboutData = [
	{
		id: 1,
		name: 'Established in 2021',
		description:'We stand as a prominent software company, dedicated to serving our valued clients since our founding in 2021.',
		imageUrl: '/images/book-check.png'
	},
	{
		id: 2,
		name: 'Location',
		description:'We have a service headquarter in Indore, India with great innovating minds.',
		imageUrl: '/images/location.png'
	},
	{
		id: 3,
		name: 'Certificates',
		description:'ISO-9001-2015 Certified for Quality.',
		imageUrl: '/images/book-mark.png'
	},
	{
		id: 4,
		name: 'Achievements in Projects',
		description:'25+ projects delivered in 2 years',
		imageUrl: '/images/diploma.png'
	},
	{
		id: 5,
		name: 'Our Area of Expertise',
		description:'Delivering Customized Assistance to Startups and SMEs – Our Expertise.',
		imageUrl: '/images/gem.png'
	},
	{
		id: 6,
		name: 'Software Recognized with Awards',
		description:'We provide resilient, scalable, and software that has earned awards for its excellence.',
		imageUrl: '/images/settings-alt.png'
	}
];

const AboutCard = () => {
	return (
		<section className="py-16 bg-white">
			<div className="max-w-7xl mx-auto px-4">
				<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
					{aboutData.map((aData) => (
						<div
							key={aData.id}
							className="bg-white rounded-2xl shadow-md hover:shadow-lg border border-gray-100 flex flex-col items-center overflow-hidden transition-all duration-300 text-center p-6"
						>
							<img
								src={aData.imageUrl}
								alt={aData.name}
								className="w-12 h-12 object-contain mb-4"
							/>
							<h3 className="text-lg sm:text-xl font-bold text-corporate-gray-dark mb-2">
								{aData.name}
							</h3>
							<p className="text-gray-600 text-sm">
								{aData.description}
							</p>
						</div>
					))}
				</div>
			</div>
		</section>
	)
}

export default AboutCard
